import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Lounge(props) {
    return (
        <SvgIcon {...props}>
            <path d="M8.8 29.9c-.9 0-1.6-.2-2.2-.5-.9-.6-1.6-1.5-2.2-3.1-1.1-3-1.7-6.5-1.7-10.3 0-4 .6-7.4 1.7-10.3.6-1.5 1.3-2.5 2.2-3 .8-.6 2-.7 3.6-.5 3.1.5 6.3 1.8 9.6 3.7l.1.1c3.3 2 5.9 4.2 7.8 6.6 1 1.2 1.5 2.4 1.5 3.4s-.5 2.2-1.5 3.4c-2 2.5-4.6 4.7-7.8 6.6l-.1.1c-3.3 1.9-6.5 3.2-9.6 3.7-.5.1-1 .1-1.4.1zm0-26c-.6 0-.9.3-1.1.4-.2.1-.8.6-1.3 2-1 2.8-1.6 6-1.6 9.6s.6 6.9 1.6 9.6c.4 1 .8 1.7 1.3 2 .3.4 1.1.5 2.2.3 2.8-.5 5.7-1.6 8.8-3.4l.1-.1c3.1-1.9 5.6-4 7.3-6.2.9-1.2 1-1.9 1-2.2 0-.6-.4-1.3-1-2.2-1.8-2.3-4.3-4.4-7.3-6.2l-.1-.1c-3.1-1.8-6-2.9-8.8-3.4-.8-.1-.9-.1-1.1-.1z" />
        </SvgIcon>
    );
}

Lounge.defaultProps = {
    viewBox: '0 0 32 32'
};

export default Lounge;
